import { commonStyles } from 'src/Library/CommonStyles';
import { tokens } from 'src/design-system';

export const CreateEnquiryStyles = (theme) => ({
  formBody: {
    backgroundColor: tokens.colors.bgWhite,
    padding: '30px 30px 30px 30px',
    height: '100%',
  },
  bottomButtons: {
    bottom: 30,
  },
  rowDiv: {
    width: '100%',
    marginBottom: '0px',
    display: 'flex',
    flexDirection: 'row',
  },
  formTitles: {
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: `${tokens.fontWeight.semibold}`,
    color: '#262626',
    lineHeight: '25px',
    marginTop: '6px',
  },
  panelHeader: {
    '& .ant-collapse .ant-collapse-item .ant-collapse-header': {
      color: `${tokens.colors.primary} !important`,
    },
    '& .ant-collapse-header': {
      color: `${tokens.colors.primary} !important`,
      backgroundColor: '#F9F9F9',
    },
  },
  formItemCountError: {
    '& .ant-form-explain': {
      marginLeft: '30%',
      fontSize: '9px',
    },
  },
  productErrorInline: {
    '& .ant-form-explain': {
      marginTop: `${tokens.spacing.xs}px`,
      marginLeft: 0,
      marginBottom: `${tokens.spacing.xs}px`,
      fontSize: `${tokens.fontSize.small}px`,
      lineHeight: '14px',
      whiteSpace: 'pre',
      overflow: 'visible',
    }
  },
  formItemSmallError: {
    '& .ant-form-explain': {
      fontSize: '9px',
    },
  },
  currentMode: {
    '& .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked': {
      backgroundColor: tokens.colors.bgWhite,
      color: '#065492',
      border: '1px solid #065492',
      zIndex: '1',
      '&:before': {
        backgroundColor: '#065492',
      },
    },
  },
  inquiryAccessDiv: {
    marginLeft: '46px',
    fontSize: `${tokens.fontSize.small}px`,
    width: '50%',
    display: 'flex',
    alignItems: 'center',
    '& .ant-select-selection--single': {
      fontSize: `${tokens.fontSize.small}px`,
    },
  },
  selectTeamModal: {
    color: '#262626',
    '& .ant-modal-body': {
      padding: `${tokens.spacing.md}px 0px`,
      height: '300px',
      overflow: 'auto',
    },
    '& .ant-modal-title': {
      fontSize: `${tokens.fontSize.h1}px`,
      padding: '5px 0px',
    },
  },
  teamsMenu: {
    borderRight: 'unset',
    '& .ant-menu-item': {
      marginBottom: '0px !important',
      margin: 0,
      padding: '0px 10px',
      height: '30px',
      '&:hover': {
        backgroundColor: '#F7F7F7',
        color: '#262626',
      },
    },
  },
  flexRow: {
    display: 'flex',
    alignItems: 'center',
  },
  accessField: {
    marginLeft: '10px',
    minWidth: '22%',
    width: 'auto',
  },
  addProduct: {
    color: tokens.colors.primary,
    padding: `${tokens.spacing.xs}px ${tokens.spacing.ms}px 6px ${tokens.spacing.ms}px`,
    cursor: 'pointer',
    fontSize: `${tokens.fontSize.small}px`,
  },
  addDetailsPlusIcon: {
    height: `${tokens.fontSize.small}px`,
    width: `${tokens.fontSize.small}px`,
    color: tokens.colors.primary,
    paddingTop: `${tokens.spacing.xxs}px`,
  },
  addDetailsCloseIcon: {
    cursor: 'pointer',
    color: 'red',
    marginTop: '13px',
    marginLeft: `${tokens.spacing.sm}px`,
  },
  containerTitle: {
    fontWeight: 'normal',
    marginRight: `${tokens.spacing.xxs}px`,
  },
  additionalDetails: {
    fontSize: `${tokens.fontSize.caption}px`,
    color: '#666666',
    fontStyle: 'italic',
  },
  docUpload: {
    color: tokens.colors.primary,
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  haulage: {
    '& .ant-radio-wrapper': {
      fontSize: '12px !important',
    },
  },
  destinationDiv: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: `${tokens.spacing.lg}px`,
    width: '75%',
    padding: 0,
  },
  hazDetails: {
    ...commonStyles(theme).flexRow,
    marginBottom: '10px',
  },
  additionalDetailsLabel: {
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
  },
  additionalCargoDetails: {
    backgroundColor: '#FCFCFC',
    borderRadius: `${tokens.radius.md}px`,
    padding: `${tokens.spacing.md}px`,
    marginBottom: `${tokens.spacing.md}px`,
  },
  additionalProductDetails: {
    fontSize: `${tokens.fontSize.small}px`,
    color: '#262626',
    fontWeight: 'bold',
    marginBottom: '6px',
  },
  addNewSelect: {
    display: 'flex',
    flexWrap: 'nowrap',
    color: tokens.colors.primary,
    padding: '6px 6px 10px',
  },
  gridLabelWidth: {
    width: '25%',
  },
  gridInputFieldWidth: {
    width: '70%',
    maxWidth: '75%'
  }
});
